import React from "react";
import styles from "./Slider.module.scss";
import classNames from "classnames";
import { digitsToHindi } from "@bale/utils";

type SliderProps = {
  min: number;
  max: number;
  value: string;
  step?: number;
  onChange?: (event: React.ChangeEvent) => void;
};

export const Slider: React.FC<React.PropsWithChildren<SliderProps>> = (props) => {
  const value = +props.value;
  const isInitial = isNaN(value);
  const step = props.step || 1;
  const stepsCount = Math.floor(props.max / step);
  const filledDotsNumber = (value || 1) - 1;
  const emptyDotsNumber = stepsCount - filledDotsNumber;

  return (
    <>
      <div className={styles.Slider}>
        <div className={styles.Points}>
          {Array.from(Array(filledDotsNumber).keys()).map((_, index) => (
            <span key={index} className={styles.Active}></span>
          ))}
          {Array.from(Array(emptyDotsNumber).keys()).map((_, index) => (
            <span key={index}></span>
          ))}
        </div>
        <style>{`#NPSProgress::before { width: ${
          +(value - 1) * 10.72
        }%; }`}</style>
        <input
          id="NPSProgress"
          type="range"
          list="values"
          dir="ltr"
          min={props.min}
          max={props.max}
          step={step}
          value={isInitial ? props.min : value}
          onChange={props.onChange}
          className={classNames(styles.Range, {
            [styles.StartingThumb]: isInitial,
          })}
        />
      </div>
      {/* There may be compatibility issues in some browsers with datalist */}
      <datalist id="values" className={styles.ScoresContainer}>
        {Array.from(Array(stepsCount).keys()).map((score) => (
          <option key={score} value={score + 1}>
            {digitsToHindi(String(score + 1))}
          </option>
        ))}
      </datalist>
    </>
  );
};
